const state = {

}

const getters = {
	usedArmorUpgradeSlots: (state, getters, rootState) => {
		var currentArmorID = rootState.Character.Current.Armor
		var currentArmor = rootState.Character.Equipment.Armor[ currentArmorID ]
		var armorUpgrades = currentArmor.Upgrades
		var usedSlots = []

		armorUpgrades.forEach( upgrade => {
			if(upgrade.Name != "")
				usedSlots.push(upgrade)
		})

		return usedSlots
	},
	hasArmorUpgrades: (state, getters, rootState) => {
		var currentArmorID = rootState.Character.Current.Armor
		var currentArmor = rootState.Character.Equipment.Armor[ currentArmorID ]
		var armorUpgrades = currentArmor.Upgrades
		var hasArmorUpgrades = false

		armorUpgrades.forEach( upgrade => {
			if(upgrade.Name != "")
				hasArmorUpgrades = true
		})

		return hasArmorUpgrades
	},
	hasShield: (state, getters, rootState) => {
		return (rootState.Character.Equipment.Shield.Name !== '')
	},
	totalAttack: (state, getters, rootState, rootGetters) => (type, misc) => {
		var typeBonus = 0;
		if(type == "Melee" || type == "Thrown"){
			typeBonus = rootGetters['character/abilityScores/abilityMods'].Strength;
		}else if(type == "Ranged" || type == "Operative"){
			typeBonus = rootGetters['character/abilityScores/abilityMods'].Dexterity;
		}
		return typeBonus + parseInt(rootState.Character.Levels[rootGetters.currentLevel].BAB) + parseInt(misc);
	},
	dexToAC: (state, getters, rootState, rootGetters) => {
		var dexMod = rootGetters['character/abilityScores/abilityMods'].Dexterity;
		var shield = rootState.Character.Equipment.Shield.MaxDex;
		var armor = rootState.Character.Equipment.Armor[rootState.Character.Current.Armor].MaxDex;
		var maxDex = 0;
		if(getters.hasShield && shield < armor){
			maxDex = shield;
		}else{
			maxDex = armor;
		}
		return ( dexMod > maxDex ? maxDex : dexMod );
	},
	totalArmor: (state, getters) => ( armorBonus, shieldBonus, miscBonus ) => {
		var dexBonus = getters.dexToAC;
		return 10 + dexBonus + armorBonus + shieldBonus + miscBonus;
	},
	calcWealth: (state, getters, rootState) => {
		var credits = parseInt(rootState.Character.Equipment.Credits);
		var armor = parseInt(rootState.Character.Equipment.Armor[rootState.Character.Current.Armor].Price);
		var weapons = 0;
		var other = 0;
		for(let i = 0; i < rootState.Character.Equipment.Weapons.length; i++){
			weapons += parseInt(rootState.Character.Equipment.Weapons[i].Price);
		}
		//containers
		for(let i = 0; i < rootState.Character.Equipment.Stored.length; i++){
			other += parseInt(rootState.Character.Equipment.Stored[i].Price);
			//items in containers
			for(let j = 0; j < rootState.Character.Equipment.Stored[i].Contents.length; j++){
				other += (parseInt(rootState.Character.Equipment.Stored[i].Contents[j].UnitPrice) * parseInt(rootState.Character.Equipment.Stored[i].Contents[j].Qty));
			}
		}
		return (credits + armor + weapons + other);
	},
	totalCarried: (state, getters, rootState) => {
		var armor = rootState.Character.Equipment.Armor[rootState.Character.Current.Armor].Bulk;
		var upgrades = 0;
		var weapons = 0;
		var equipped = 0;
		var magic = 0;
		var other = 0;
		for(let i = 0; i < rootState.Character.Equipment.Weapons.length; i++){
			weapons += rootState.Character.Equipment.Weapons[i].Bulk;
		}
		//armor upgrades
		rootState.Character.Equipment.Armor[rootState.Character.Current.Armor].Upgrades.forEach(function(value){
			upgrades += value.Bulk;
		})
		//containers
		for(let i = 0; i < rootState.Character.Equipment.Stored.length; i++){
			if(rootState.Character.Equipment.Stored[i].Extradimensional==true){
				//just the weight of the container, not the contents
				other += rootState.Character.Equipment.Stored[i].Bulk;
			}else{
				//items in containers, not the container
				for(let j = 0; j < rootState.Character.Equipment.Stored[i].Contents.length; j++){
					other += (rootState.Character.Equipment.Stored[i].Contents[j].UnitBulk * rootState.Character.Equipment.Stored[i].Contents[j].Qty);
				}
			}
		}
		//equipped
		rootState.Character.Equipment.Equipped.forEach(function(item){
			equipped += item.Bulk;
		})
		//magic
		rootState.Character.Equipment.Magic.forEach(function(item){
			magic += item.Bulk;
		})
		return (armor + upgrades + weapons + equipped + magic + other).toFixed(1);
	},
	weapons: (state, getters, rootState) => {
		return  Object.assign({}, rootState.Character.Current.Ammunition)
	}
}

const actions = {

}

const mutations = {

}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
}